<template>
  <div class="login">
    <img class="imgr" src="../assets/lo.png" alt="">
    <div class="login_cont">
      <!-- 移动端隐藏左侧图片 -->
      <div class="login_l hidden-md-and-down">
        <img src="../assets/login-l.png" alt="">
      </div>
      <div class="login_r">

        <div>
          <div class="tit_flex">
            <div class="title">欢迎登录</div>
            <img src="../assets/login1.png" alt="">
          </div>
          <!-- 登录方式切换 -->
          <div v-if="!isMobile" class="login-type-switch" @click="toggleLoginType">
            {{ showForm ? '微信扫码登录' : '账号密码登录' }}
          </div>

          <div v-else class="login-type-switch-moblie" @click="toggleLoginType">
            {{ showForm ? '微信一键登录' : '账号密码登录' }}
          </div>

        </div>


        <!-- PC端微信扫码登录 -->
        <div v-if="!isMobile && !showForm" class="wx-login-pc">
          <!-- <div class="wx-login-pc-border"></div> -->
          <div class="wx-login-pc-title">
            <img src="../assets/wechat-icon.png" class="wx-login-pc-img" alt="微信登录">
            <span>微信扫码登录</span>
          </div>
          <div id="wx-qrcode-container"></div>
        </div>

        <!-- 移动端微信一键登录 -->
        <div v-if="isMobile && !showForm" class="wx-login-mobile">
          <div class="wx-btn" @click="handleWechatLogin">
            <img src="../assets/wechat-icon.png" alt="微信登录">
            <span>微信一键登录</span>
          </div>
        </div>

        <el-form v-show="showForm" ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
          <el-form-item prop="account">
            <el-input v-model="loginForm.account" type="text" auto-complete="off" placeholder="请输入账号">
              <img class="input-icon" slot="prefix" src="../assets/zh.png" alt="" srcset="">
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="loginForm.password" auto-complete="off" placeholder="请输入密码" show-password @keyup.enter.native="handleLogin">
              <img class="input-icon" slot="prefix" src="../assets/mm.png" alt="" srcset="">
            </el-input>
          </el-form-item>
          <div class="tj">
            <!-- 自动保存密码复选框 -->
            <span>
              <el-checkbox v-model="loginForm.rememberPassword">自动保存密码</el-checkbox>
            </span>
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">请联系平台客服重置密码<br />联系电话19181377185</div>
              <span>
                忘记密码
              </span>
            </el-tooltip>
          </div>

          <el-form-item style="width:100%;">
            <div class="btns" @click="handleLogin()">
              <span v-if="!loading">登 录</span>
              <span v-else>登 录 中...</span>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="f4">
      备案号：<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">蜀ICP备2024109498号-1</a>
    </div>
  </div>
</template>

<script>
import { getUserSig } from '@/api/txim.js'
import { userLogin,userWxLogin } from '@/api/login.js'
import { setToken } from '@/utils/auth'
import Cookies from 'js-cookie'

export default {
  name: 'login',
  data() {
    return {
      loading: false,
      loginForm: {
        account: "",
        password: "",
        role: 1,
        rememberPassword: false, // 自动保存密码
      },
      loginRules: {
        account: [
          { required: true, trigger: "blur", message: "请输入您的账号" }
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" }
        ]
      },
      showForm: false, // 控制表单显示
      isMobile: false, // 是否移动端
      wxLoginObj: null, // 微信登录对象
      redirectUri:window.location.href
    }
  },
  mounted() {
    // 页面加载时检查是否有保存的账号和密码
    const savedAccount = localStorage.getItem('iTflA4u4');
    const savedPassword = localStorage.getItem('2W8YSkty');
    if (savedAccount && savedPassword) {
      this.loginForm.account = this.decryptPassword(savedAccount);
      this.loginForm.password = this.decryptPassword(savedPassword); // 解密密码
      this.loginForm.rememberPassword = true;
    }
    
    this.checkMobile();
    this.initWxLogin();
    this.handleCallback();
  },
  methods: {
    checkMobile() {
      this.isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
    },
    // 初始化微信登录
    initWxLogin() {
      if (!this.isMobile) {
        // PC端扫码登录
        this.loadScript('https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js').then(() => {
          this.wxLoginObj = new WxLogin({
            id: "wx-qrcode-container",
            appid: "wxb87c64c2f7730c8c", // 替换为实际appid
            scope: "snsapi_login",
            redirect_uri: encodeURIComponent(this.redirectUri), // 替换为实际回调地址
            state: "STATE",
            style: "black",
            stylelite:1,
            href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIyNnB4O2hlaWdodDogMjEzcHg7Ym9yZGVyOjBweDttYXJnaW4tdG9wOiAzMHB4O30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAyMjZweDttYXJnaW46IDAgYXV0bzt9Ci5pbXBvd2VyQm94IC5zdGF0dXMgeyBwYWRkaW5nOiAycHggNHB4O3RleHQtYWxpZ246IGNlbnRlcjt9IAouaW1wb3dlckJveHttYXJnaW4tdG9wOiA4MHB4O30K",
          });
        });
      }
    },
    // 动态加载脚本
    loadScript(src) {
      return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        document.body.appendChild(script);
      });
    },

    // 微信登录按钮点击
    handleWechatLogin() {
      if (this.isMobile) {
        // 微信浏览器内授权登录
        const redirectUri = encodeURIComponent(this.redirectUri);
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx7a4b08a9fc327f3e&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=111111#wechat_redirect`;
      }
    },
    // 切换登录方式
    toggleLoginType() {
      this.showForm = !this.showForm;
      if (!this.isMobile) {
        if(this.showForm)
        {
          document.getElementById('wx-qrcode-container').style.display = 'none';
        }else{
          this.initWxLogin()
        }
      }

    },

    // 简单加密函数
    encryptPassword(password) {
      return btoa(encodeURIComponent(password)); // 先编码中文，再 Base64
    },
    // 简单解密函数
    decryptPassword(encryptedPassword) {
      return decodeURIComponent(atob(encryptedPassword)); // 先 Base64 解码，再解码中文
    },
    delCookie() {
      localStorage.removeItem('hyinfo')
      localStorage.removeItem('userinfo')
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie =
          name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
      }
      if (cookies.length > 0) {
        for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i];
          var eqPos = cookie.indexOf("=");
          var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          var domain = location.host.substr(location.host.indexOf("."));
          document.cookie =
            name +
            "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" +
            domain;
        }
      }
    },
    // 处理回调逻辑
    handleCallback() {
      const urlParams = new URLSearchParams(window.location.search)
      const code = urlParams.get('code')

      if (code) {
        let that = this
        // 向后端发送请求
        that.loading = true;
         userWxLogin({code:code,role:1,isMoblie:that.isMobile}).then(res => {
            if (res.code == 1) {
              getUserSig({ user_id: res.data.userinfo.id }).then(r => {
                let promise = that.tim.login({ userID: 'xj' + res.data.userinfo.id, userSig: r.data })
                promise.then(function (imResponse) {
                  setToken(res.data.userinfo.token)
                  that.$store.commit('SetUserinfo', res.data.userinfo)
                  that.$store.commit('Setisload', 1)
                  that.$router.replace({ path: "/" })
                }).catch(function (imError) {
                  console.warn('login error:', imError); // 登录失败的相关信息
                });
              })
            }else{
              that.$router.replace({ path: "/login" })
            }
            that.loading = false;
         }).catch(err=>{
           console.warn('login error:', err);
           that.$router.replace({ path: "/login" })
         })

      }
    },
    handleLogin() {
      let that = this
      that.$refs.loginForm.validate(valid => {
        if (valid) {
          that.loading = true;
          that.delCookie()
          userLogin(that.loginForm).then(res => {
            if (res.code == 1) {
              // 如果用户选择了自动保存密码，保存账号和加密后的密码
              if (that.loginForm.rememberPassword) {
                localStorage.setItem('iTflA4u4', this.encryptPassword(that.loginForm.account));
                localStorage.setItem('2W8YSkty', this.encryptPassword(that.loginForm.password)); // 加密密码
              } else {
                // 如果用户取消勾选，清除保存的账号和密码
                localStorage.removeItem('iTflA4u4');
                localStorage.removeItem('2W8YSkty');
              }

              getUserSig({ user_id: res.data.userinfo.id }).then(r => {
                let promise = that.tim.login({ userID: 'xj' + res.data.userinfo.id, userSig: r.data })
                promise.then(function (imResponse) {
                  setToken(res.data.userinfo.token)
                  that.$store.commit('SetUserinfo', res.data.userinfo)
                  that.$store.commit('Setisload', 1)
                  that.$router.push({ path: "/" })
                }).catch(function (imError) {
                  console.warn('login error:', imError); // 登录失败的相关信息
                });
              })
            }
            that.loading = false;
          })
        }
      });
    },
  },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.imgr {
  width: 219px;
  height: 46px;
  position: absolute;
  top: 30px;
  left: 110px;

  @media (max-width: 768px) {
    width: 150px;
    height: auto;
    left: 50%;
    transform: translateX(-50%);
  }
}

.f4 {
  position: absolute;
  bottom: 30px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #ADAAAA;

  @media (max-width: 768px) {
    font-size: 12px;
    bottom: 10px;
    text-align: center;
    width: 100%;
  }

  a {
    color: #ADAAAA;
    text-decoration: none;

    &:hover {
      color: #000;
    }
  }
}

.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url("../assets/login-background.png");
  background-size: cover;

  @media (max-width: 768px) {
    padding: 20px;
    background-size: contain;
  }
}

.login_cont {
  display: flex;
  box-shadow: 0px 0px 32px 5px rgba(65, 113, 202, 0.47);
  height: 600px;

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }

  .login_l {
    width: 600px;

    @media (max-width: 768px) {
      display: none; // 移动端隐藏左侧图片
    }

    img {
      width: 100%;
      height: auto;
    }
  }

  .login_r {
    width: 600px;
    background: #ffffff;
    padding: 148px 70px;
    box-sizing: border-box;
 

    @media (max-width: 768px) {
      width: 100%;
      padding: 40px 20px;
    }

    .tit_flex {
      display: flex;
      align-items: center;
      // margin-bottom: 32px;

      img {
        width: 39px;
        height: 30px;
        margin-left: 24px;

        @media (max-width: 768px) {
          width: 30px;
          height: 24px;
          margin-left: 10px;
        }
      }
    }

    .title {
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 32px;
      color: #000000;
      line-height: 38px;

      @media (max-width: 768px) {
        font-size: 24px;
      }
    }
  }
}

.login-form {
  border-radius: 6px;
  background: #ffffff;

  ::v-deep .el-input {
    height: 50px;

    input {
      height: 50px;
    }
  }

  ::v-deep .el-input--prefix .el-input__inner {
    padding-left: 40px !important;
  }

  .el-form-item {
    margin-top: 29px;
    margin-bottom: 0px;
  }

  .input-icon {
    height: 24px;
    width: 24px;
    margin-left: 2px;
    margin: 13px 4px;
  }

  .tj {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #666666;
    line-height: 16px;
    text-align: right;
    margin-top: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }

  .btns {
    width: 460px;
    height: 50px;
    background: #FFDB0C;
    border-radius: 6px;
    font-family: PingFang SC, PingFang SC;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
    line-height: 50px;
    cursor: pointer;
    margin-top: 20px;

    @media (max-width: 768px) {
      width: 100%;
      font-size: 14px;
    }
  }
}

/* 新增微信登录样式 */
.wx-login-pc {
  text-align: center;
  margin-top: 10px;
  width: 460px;
  height: 300px;
  position: relative;

  .wx-login-pc-title{
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    margin-right: 10px;
  }

  .wx-login-pc-border{
    width: 210px;
    height: 210px;
    border: 1px solid #DEDEDE;
    position: absolute;
    left: 120px;
    top:-10px;
  }

  .wx-login-pc-img{
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: 10px;
  }

}



.wx-login-mobile {
  text-align: center;
  width: 60%;
  margin-left: 12%;
  margin-top: 20px;
}

.wx-btn {
  display: inline-flex;
  align-items: center;
  padding: 12px 24px;
  background: #059b4d;
  border-radius: 10px;
  color: white;
  cursor: pointer;
}

.wx-btn img {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  border-radius: 20%;
}

.login-type-switch {
  text-align: center;
  color: #409EFF;
  margin-top: 10px;
  cursor: pointer;
  font-size: 14px;
  width: 30%;
  margin-left: -20px;
}

.login-type-switch-moblie{
  text-align: center;
  color: #409EFF;
  margin-top: 10px;
  cursor: pointer;
  font-size: 14px;
  width: 30%;
}

@media (max-width: 768px) {
  .wx-btn {
    width: 100%;
    justify-content: center;
  }
  
  #wx-qrcode-container {
    width: 220px;
    height: 220px;
  }
}



</style>